import styled from 'styled-components';

export const HelperBoxContainer = styled.div `
    margin-top: var(--spacing-regular);
    margin-bottom: var(--spacing-regular);
    display: flex;
    padding: var(--spacing-regular);
    border: 1px solid var(--color-neutral-light-darker);
    gap: var(--spacing-small);

    @media (max-width: 1280px) {
      margin-top: var(--spacing-small);
      margin-bottom: var(--spacing-small);
      padding: var(--spacing-small);
    }
`

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const HelpText = styled.span`
  font-size: var(--font-giant);
  color: var(--color-text);
  font-weight: semi-bold;
    @media (max-width: 1280px) {
      font-size: var(--font-regular);
    }
`;

export const HelpTextSmall = styled.span`
  margin-top: var(--spacing-small);
  color: var(--color-neutral-dark-lighter);
  font-size: var(--font-regular);

    @media (max-width: 1280px) {
      font-size: var(--font-small);
    }
`

export const ContactLink = styled.a`
  font-size: var(--font-medium);
  color: var(--color-detached);
    padding-top:  var(--spacing-small);
    padding-left:  var(--spacing-small);
    text-decoration: underline;

  &:hover {
    text-decoration: underline;
  }
`;

export const IconWrapper = styled.div`
    margin-top: 3px;
    font-size: var(--font-medium);
    color: var(--color-neutral-dark-darker);
`;

// Componentes dinâmicos para HelpBox Default
interface HelpBoxDefaultContainerProps {
  styles: {
    background: string;
    border: string;
    borderRadius: string;
    boxShadow: string;
    padding: string;
    gap: string;
    marginTop: string;
    marginBottom: string;
  };
}

export const HelpBoxDefaultContainer = styled.div<HelpBoxDefaultContainerProps>`
  background: ${props => props.styles.background};
  border: ${props => props.styles.border};
  border-radius: ${props => props.styles.borderRadius};
  box-shadow: ${props => props.styles.boxShadow};
  opacity: 1;
  display: flex;
  padding: ${props => props.styles.padding};
  gap: ${props => props.styles.gap};
  margin-top: ${props => props.styles.marginTop};
  margin-bottom: ${props => props.styles.marginBottom};
`;

interface HelpBoxDefaultIconProps {
  styles: {
    marginTop: string;
    fontSize: string;
    color: string;
  };
}

export const HelpBoxDefaultIcon = styled.div<HelpBoxDefaultIconProps>`
  margin-top: ${props => props.styles.marginTop};
  font-size: ${props => props.styles.fontSize};
  color: ${props => props.styles.color};
`;

interface HelpBoxDefaultContentProps {
  styles: {
    gap: string;
  };
}

export const HelpBoxDefaultContent = styled.div<HelpBoxDefaultContentProps>`
  display: flex;
  flex-direction: column;
  gap: ${props => props.styles.gap};
`;

interface HelpBoxDefaultTitleProps {
  styles: {
    fontSize: string;
    color: string;
    fontWeight: string;
  };
}

export const HelpBoxDefaultTitle = styled.span<HelpBoxDefaultTitleProps>`
  font-size: ${props => props.styles.fontSize};
  color: ${props => props.styles.color};
  font-weight: ${props => props.styles.fontWeight};
`;

interface HelpBoxDefaultLinkProps {
  styles: {
    fontSize: string;
    color: string;
    fontWeight: string;
  };
  hoverStyles: {
    color: string;
  };
}

export const HelpBoxDefaultLink = styled.a<HelpBoxDefaultLinkProps>`
  font-size: ${props => props.styles.fontSize};
  color: ${props => props.styles.color};
  text-decoration: none;
  font-weight: ${props => props.styles.fontWeight};
  cursor: pointer;

  &:hover {
    text-decoration: underline;
    color: ${props => props.hoverStyles.color};
  }
`;

// Componentes dinâmicos para HelpBox Contact
interface HelpBoxContactContainerProps {
  styles: {
    background: string;
    border: string;
    borderRadius: string;
    boxShadow: string;
    padding: string;
    gap: string;
    marginTop: string;
    marginBottom: string;
    width: string;
  };
}

export const HelpBoxContactContainer = styled.div<HelpBoxContactContainerProps>`
  background: ${props => props.styles.background};
  border: ${props => props.styles.border};
  border-radius: ${props => props.styles.borderRadius};
  box-shadow: ${props => props.styles.boxShadow};
  opacity: 1;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: ${props => props.styles.padding};
  gap: ${props => props.styles.gap};
  margin-top: ${props => props.styles.marginTop};
  margin-bottom: ${props => props.styles.marginBottom};
  width: ${props => props.styles.width};
`;

interface HelpBoxContactContentProps {
  styles: {
    gap: string;
    width: string;
    textAlign: string;
    paddingLeft: string;
  };
}

export const HelpBoxContactContent = styled.div<HelpBoxContactContentProps>`
  display: flex;
  flex-direction: column;
  gap: ${props => props.styles.gap};
  width: ${props => props.styles.width};
  text-align: ${props => props.styles.textAlign};
  padding-left: ${props => props.styles.paddingLeft};
`;

interface HelpBoxContactTitleProps {
  styles: {
    fontSize: string;
    color: string;
    fontWeight: string;
  };
}

export const HelpBoxContactTitle = styled.span<HelpBoxContactTitleProps>`
  font-size: ${props => props.styles.fontSize};
  color: ${props => props.styles.color};
  font-weight: ${props => props.styles.fontWeight};
`;

interface HelpBoxContactInfoProps {
  styles: {
    gap: string;
    marginTop: string;
    textAlign: string;
  };
}

export const HelpBoxContactInfo = styled.div<HelpBoxContactInfoProps>`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: ${props => props.styles.gap};
  margin-top: ${props => props.styles.marginTop};
  text-align: ${props => props.styles.textAlign};
`;

interface HelpBoxContactPhoneProps {
  styles: {
    fontSize: string;
    color: string;
    textAlign: string;
  };
}

export const HelpBoxContactPhone = styled.div<HelpBoxContactPhoneProps>`
  font-size: ${props => props.styles.fontSize};
  color: ${props => props.styles.color};
  text-align: ${props => props.styles.textAlign};
`;

interface HelpBoxContactScheduleProps {
  styles: {
    fontSize: string;
    color: string;
    lineHeight: string;
    textAlign: string;
  };
}

export const HelpBoxContactSchedule = styled.div<HelpBoxContactScheduleProps>`
  font-size: ${props => props.styles.fontSize};
  color: ${props => props.styles.color};
  line-height: ${props => props.styles.lineHeight};
  text-align: ${props => props.styles.textAlign};
`;

interface HelpBoxContactWhatsappIconProps {
  styles: {
    fontSize: string;
    color: string;
    marginRight: string;
  };
}

export const HelpBoxContactWhatsappIcon = styled.span<HelpBoxContactWhatsappIconProps>`
  font-size: ${props => props.styles.fontSize};
  color: ${props => props.styles.color};
  margin-right: ${props => props.styles.marginRight};
`;
